import { useState } from "react";
import { Link } from "react-router-dom";
import useApiQuery from "../hooks/useApiQuery";
import endpoints from "../api/endpoints";

/** Hover panel listing every category group and its children. */
const CategoryMegaMenu = () => {
  const { data } = useApiQuery(endpoints.categories());
  const [activeIndex, setActiveIndex] = useState(0);
  const groups = data ?? [];

  if (groups.length === 0) return null;

  return (
    <div
      className="z-[1000] mt-5 flex flex-row justify-center gap-4 rounded-md bg-gray-800 px-8 py-5 text-white"
      style={{ width: `${groups.length * 200}px` }}
    >
      {groups.map((group, index) => (
        <div
          key={group.id}
          className="cursor-pointer"
          style={{ width: `${100 / groups.length}%` }}
          onMouseEnter={() => setActiveIndex(index)}
        >
          <p className="mb-4 flex items-center text-2xl font-bold transition hover:text-brand">
            {group.title}
            <span className="m-2 text-xs">▼</span>
          </p>
          {activeIndex === index && (
            <div>
              {group.children?.map((child) => (
                <div key={child.id}>
                  <Link
                    to={`/category/${child.slug}`}
                    className="font-normal transition hover:text-brand"
                  >
                    {child.title}
                  </Link>
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default CategoryMegaMenu;
